"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.StyledTooltip = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Typography = require("../Typography");

var _Layout = require("../Layout");

var _functions = require("./functions");

var availablePos = ['top', 'bottom', 'left', 'right'];
var StyledTooltip = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Tooltip__StyledTooltip",
  componentId: "sc-1927wc4-0"
})({
  willChange: 'transform',
  zIndex: 1080,
  textAlign: 'start'
}, (0, _styledSystem.variant)({
  prop: 'tooltipPosition',
  variants: {
    top: {
      paddingY: 1,
      paddingX: 0
    },
    bottom: {
      paddingY: 1,
      paddingX: 0
    },
    right: {
      paddingY: 0,
      paddingX: 1
    },
    left: {
      paddingY: 0,
      paddingX: 1
    }
  }
}));
exports.StyledTooltip = StyledTooltip;
var StyledTooltipArrow = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Tooltip__StyledTooltipArrow",
  componentId: "sc-1927wc4-1"
})({
  width: '9px',
  height: '5px',
  '::before': {
    position: 'absolute',
    bottom: 0,
    borderColor: 'transparent',
    borderStyle: 'solid',
    content: "''"
  }
}, (0, _styledSystem.variant)({
  prop: 'tooltipPosition',
  variants: {
    top: {
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      '::before': {
        top: '0',
        borderWidth: '5px 5px 0px',
        borderTopColor: 'sonar',
        content: "''"
      }
    },
    bottom: {
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      '::before': {
        bottom: 0,
        borderWidth: '0px 5px 5px',
        borderBottomColor: 'sonar',
        content: "''"
      }
    },
    right: {
      top: '50%',
      left: 0,
      width: '5px',
      height: '9.59375px',
      transform: 'translateY(-50%)',
      '::before': {
        right: 0,
        borderWidth: '5px 5px 5px 0px',
        borderRightColor: 'sonar',
        content: "''"
      }
    },
    left: {
      top: '50%',
      right: 0,
      width: '5px',
      height: '9.59375px',
      transform: 'translateY(-50%)',
      '::before': {
        left: 0,
        borderWidth: '5px 0px 5px 5px',
        borderLeftColor: 'sonar',
        content: "''"
      }
    }
  }
}));

var Tooltip = function Tooltip(props) {
  var message = props.message,
      position = props.position,
      id = props.id,
      relativeElementPosition = props.relativeElementPosition;
  var tooltipNode = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      coordinates = _useState2[0],
      setCoordinates = _useState2[1];

  var _useState3 = (0, _react.useState)(position),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      updatedPosition = _useState4[0],
      updatePosition = _useState4[1];

  var _useState5 = (0, _react.useState)(availablePos.filter(function (pos) {
    return pos !== position;
  })),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      availablePositions = _useState6[0],
      updateAvailablePositions = _useState6[1];

  var calculateCoordinates = function calculateCoordinates() {
    if (!relativeElementPosition) {
      return;
    }

    var tooltipRect = tooltipNode.current.getBoundingClientRect();
    var x = (0, _functions.getXTranslation)(tooltipRect, relativeElementPosition, updatedPosition);
    var y = (0, _functions.getYTranslation)(tooltipRect, relativeElementPosition, updatedPosition);

    if (!(0, _functions.validCoordinates)(x, y, tooltipRect.width, tooltipRect.height)) {
      var leftPositions = availablePositions;
      var newPosition = leftPositions.shift();
      updatePosition(newPosition);
      updateAvailablePositions(leftPositions);
      return;
    }

    setCoordinates({
      x: x,
      y: y
    });
  };

  (0, _react.useEffect)(function () {
    calculateCoordinates();
  }, [relativeElementPosition, updatedPosition]);
  var style = {
    visibility: 'hidden'
  };

  if (coordinates) {
    style = {
      transform: "translate3d(".concat(coordinates.x, "px, ").concat(coordinates.y, "px, 0px)")
    };
  }

  return _react.default.createElement(StyledTooltip, {
    role: "tooltip",
    id: id,
    xPlacement: updatedPosition,
    tooltipPosition: updatedPosition,
    style: style,
    ref: tooltipNode,
    position: "absolute",
    top: "0",
    left: "0",
    maxWidth: "206px"
  }, _react.default.createElement(StyledTooltipArrow, {
    position: "absolute",
    tooltipPosition: updatedPosition
  }), _react.default.createElement(_Layout.Box, {
    paddingY: [2, 2, 3],
    paddingX: [2, 2, 4],
    color: "coco",
    backgroundColor: "sonar",
    borderRadius: 3
  }, _react.default.createElement(_Typography.Text, {
    size: "micro",
    color: "coco",
    fontWeight: "regular",
    textAlign: "center"
  }, message)));
};

exports.Tooltip = Tooltip;
Tooltip.defaultProps = {
  id: 'dmstkTooltip01',
  message: "I'm a tooltip",
  position: 'top',
  relativeElementPosition: null
};